<template>
  <v-card>
    <v-card-title>
      <v-container fluid
                   class="panel">
        <v-layout row
                  wrap>
          <v-flex xs12
                  class="panel-heading">
            <h2 class="panel-title">
              <b>
                <span v-html="$t('private_parking_reports_table_title')"></span>
              </b>
              <from-to-date-selector @on-dates-selected="updateDates"
                                     :hide-refresh="true"
                                     class="dates"></from-to-date-selector>
            </h2>
          </v-flex>
        </v-layout>

        <v-select :items="reportsSimplified"
                  v-model="reportSelected"
                  class="input-group--focused spacing-top"
                  item-text="text"
                  item-value="key"></v-select>

        <v-btn @click="downloadReport"
               color="cyan"
               class="white--text capitalize"
               block
               v-html="$t('private_parking_reports_button_download')"></v-btn>

      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import keys from '@/store/keys';
import reportService from '@/services/reportService';
import FromDateSelector from '@/components/commons/FromToDateSelector.vue';
import moment from 'moment';
import _ from 'lodash';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'report-box-download',
  props: ['parkingId'],
  components: {
    [FromDateSelector.name]: FromDateSelector
  },
  data() {
    return {
      reports: [],
      reportsSimplified: [],
      dates: [],
      reportSelected: null,
      isLoading: false
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    updateDates(dates) {
      this.dates = dates;
    },
    loadData() {
      let params = {
        parking: this.parkingId
      };
      reportService.list(params, this.reportListSuccessHandler, this.reportListErrorHandler);
    },
    reportListSuccessHandler(data) {
      this.reports = data;
      this.reportsSimplified = [];
      _.each(this.reports, (itReport, key) => {
        itReport.text = `${key} (${itReport.format})`;
        itReport.key = key;
        this.reportsSimplified.push(itReport);
      });
      // this.reportSelected = _.findKey(this.reports, x => true);
      this.reportSelected = this.reportsSimplified[0];
    },
    reportListErrorHandler() {},
    downloadReport() {
      if (this.reportSelected === null) {
        return;
      }
      let params = {
        parking: this.parkingId,
        start: moment(this.dates[0]).format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
        end: moment(this.dates[1]).format('YYYY-MM-DD[T]HH:mm:ss[Z]')
      };
      this.isLoading = true;
      reportService.bookings(params, this.bookingsSuccessHandler, this.bookingsErrorHandler);
    },
    bookingsSuccessHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        message: data[0],
        doNotTranslate: true,
        type: 'accent'
      });
    },
    bookingsErrorHandler(data) {
      this.isLoading = false;
      EventBus.$emit(keys.eventOnShowNotification, {
        message: data[0],
        doNotTranslate: true,
        type: 'error'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/ReportBoxDownload.vue